import React from 'react';

import { PetitionCard } from '@change/ds-core-ui/next';

import { useI18n } from '@change-corgi/core/react/i18n';

import type { SuggestedPetition } from '../../../../../../shared/api';
import type { SuggestedPetitionSourceLocation } from '../../../../../../shared/types';

import { useSuggestedPetitionCardDs2 } from './hooks/useSuggestedPetitionCard/useSuggestedPetitionCardDs2';

type Props = Readonly<{
	petition: SuggestedPetition;
	parentPetitionId?: string;
	gridPosition: number;
	sourceLocation: SuggestedPetitionSourceLocation;
}>;

export const SuggestedPetitionCard: React.FC<Props> = ({
	petition,
	parentPetitionId,
	gridPosition,
	sourceLocation,
}) => {
	const {
		data: {
			imageUrl,
			isVictory,
			location,
			petitionId,
			petitionLinkUrl,
			promoterCount,
			promoterCountLocalized,
			promotersLinkUrl,
			signLinkUrl,
			supporterCount,
			supporterCountLocalized,
			title,
		},
		actions: { signLinkOnClick, petitionLinkOnClick, promotersLinkOnClick },
	} = useSuggestedPetitionCardDs2({
		parentPetitionId,
		petition,
		gridPosition,
		sourceLocation,
	});
	const { translate, translatePlural } = useI18n();

	return (
		<PetitionCard
			className="h-full max-w-full"
			imageUrl={imageUrl}
			isVictory={isVictory}
			location={location}
			petitionId={petitionId}
			petitionLinkUrl={petitionLinkUrl}
			promotersLabel={translatePlural('corgi.components.petition_card.promoted_by', promoterCount, {
				promoterCount: promoterCountLocalized,
			})}
			promotersLinkUrl={promotersLinkUrl}
			signaturesLabel={translatePlural('corgi.components.petition_card.signatures', supporterCount, {
				countLocalized: supporterCountLocalized,
			})}
			signLinkUrl={signLinkUrl}
			title={title}
			signPetitionLabel={translate('corgi.components.petition_card.sign_button_label')}
			victoryLabel={translate('corgi.components.petition_card.victory')}
			signLinkOnClick={signLinkOnClick}
			petitionLinkOnClick={petitionLinkOnClick}
			promotersLinkOnClick={promotersLinkOnClick}
		/>
	);
};
